import { gql } from 'graphql-tag';
const GET_EVENTS = gql`
	query getEvents(
		$name: String = null
		$dateFrom: String
		$dateTo: String
		$typeIds: [Int]
		$locationIds: [Int]
		$product: Product
		$sortBy: OpenDaysSortBy
		$sortDirection: SortDirection
		$page: Int
		$limit: Int
		$offset: Int
	) {
		events(
			name: $name
			date_from: $dateFrom
			date_to: $dateTo
			type_ids: $typeIds
			location_ids: $locationIds
			product: $product
			sort_by: $sortBy
			sort_direction: $sortDirection
			page: $page
			limit: $limit
			offset: $offset
		) {
			data {
				id
				title
				subtitle
				description
				product
				type
				date
				external_url
				university {
					id
					name
					logo
					slug
					order
					privacy_policy_url
				}
			}
			recommended_events {
				id
				title
				subtitle
				description
				product
				type
				date
				external_url
				university {
					id
					name
					logo
					slug
					order
					privacy_policy_url
				}
			}
			per_page
			current_page
			has_more_pages
			total
			filters {
				name
				values {
					id
					count
				}
			}
		}
	}
`;
export { GET_EVENTS };
